import { createSelector } from 'reselect';

const substate = (state) => state.payment;

export const selectPaymentEmail = () => createSelector(substate, (contextState) => contextState.paymentEmail);
